import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import {ValidateStep4Data} from "@validators/van-insurance-form/step4-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {
   CommonAdditionalDriverForm
} from "@components/common/sub-components/insurance-form-parts/additional-driver-form/common-additional-driver-form";
import {TermsAgreementBlock} from "@components/common/form-blocks/other/terms-agreement-block";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step4(
   {
      data,
      handlers,
      setCurrentStep,
      
      addAdditionalDriver,
      removeAdditionalDiverByIndex,
      handleAdditionalDiverPropChange,
      
      
      handleAdditionalDriverAccidentPropChange,
      addAdditionalDriverAccident,
      removeAdditionalDriverAccident,
      
      handleAdditionalDriverConvictionPropChange,
      addAdditionalDriverConviction,
      removeAdditionalDriverConviction,
      
      onSubmit,
      formRef
   }) {
   
   const STEP = 4;
   
   const onPrevBtnClick = (event) => {
      setCurrentStep(STEP - 1);
   }
   
   const onNextBtnClick = (event) => {
      
      let validationResult = ValidateStep4Data(data);
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         onSubmit();
      }
      
      
   }
   
   return (
      <div className='if-step-4'>
         
         <CommonAdditionalDriverForm
            sectionHeading="Additional Drivers"
            data={data}
            
            buttonGroupOnChange={handlers.onControlChange}
            buttonGroupLabel="Would you like to add an additional driver?"
            
            addAdditionalDriver={addAdditionalDriver}
            handleAdditionalDiverPropChange={handleAdditionalDiverPropChange}
            removeAdditionalDiverByIndex={removeAdditionalDiverByIndex}
            
            handleAdditionalDriverAccidentPropChange={handleAdditionalDriverAccidentPropChange}
            addAdditionalDriverAccident={addAdditionalDriverAccident}
            removeAdditionalDriverAccident={removeAdditionalDriverAccident}
            
            handleAdditionalDriverConvictionPropChange={handleAdditionalDriverConvictionPropChange}
            addAdditionalDriverConviction={addAdditionalDriverConviction}
            removeAdditionalDriverConviction={removeAdditionalDriverConviction}
         />
         
         {/* Additional comments */}
         
         <ScrollableTextBoxBlock
            containerCssClass="col-12 py-3 "
            labelText="Additional comments"
            required={false}
            controlName="addAdditionalComments"
            value={data.addAdditionalComments}
            onChange={handlers.onControlChange}
            inputAttrs={{
               maxLength: 1024,
               rows: 5
            }}
            asTextArea={true}
         />
         
         <TermsAgreementBlock
            controlName={"termsAgreement"}
            controlIdPrefix={"termsAgreement-"}
            required={true}
            onChange={handlers.onControlChange}
            selectedValue={data.termsAgreement}
            labelText={"Terms agreement"}
            isHidden={false}
         />
         
         
         <WizardStepButtonsBlock
            prevBtnText={"Previous"}
            onPrevBtnClick={onPrevBtnClick}
            nextBtnText={"Submit"}
            onNextBtnClick={onNextBtnClick}
            nextBtnIconClass={"fa fa-fw fa-save me-2"}
            nextBtnIconPosition={"left"}
            isNextBtnDisabled={data.termsAgreement !== 'Yes'}
         />
         
         
         {/*<div className="col mb-3">
            <label className="form-label">
               Terms agreement <RequiredSign
               required={true} />
            </label>
            
            <div>
               <ButtonGroup
                  selectedValue={data.termsAgreement}
                  idPrefix="termsAgreement-"
                  name="termsAgreement"
                  options={TERMS_AGREEMENT_CHOICE_OPTIONS}
                  onChange={handlers.onControlChange}
                  required={true}
               />
            </div>
            
            <div className="form-text">By clicking submit, you agree your explicit consent for us to use the data
               provided in accordance with the Data Protection act 2018, this data will be used to provide the
               cheapest possible quote while being shared with both offline and online markets.
            </div>
         
         </div>*/}
         {/* controlName */}
         
         
         {/*
                Step buttons ....
            */}
         
        {/* <div className="row mt-5">
            <div className="col d-flex justify-content-between">
               <button
                  id="btn-step2-prev"
                  type="button"
                  className="btn btn-info btn-steps mb-3 min-width-200px"
                  onClick={onPrevBtnClick}
               >
                  <i className="fa fa-chevron-left" /> Previous
               </button>
               
               <button
                  id="btn-step3-next"
                  type="button"
                  className="btn btn-success btn-steps mb-3 min-width-200px"
                  disabled={data.termsAgreement !== 'Yes'}
                  onClick={onNextBtnClick}
                  style={{
                     position: 'fixed',
                     right: 30,
                     bottom: 100
                  }}
               >
                  Send <i className="fa fa-chevron-right" />
               </button>
            </div>
         </div>*/}
      
      
      </div>
   );
}